module.exports = __webpack_public_path__ + "img/17.bb239195.jpg";